import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


// کامپوننت‌های لندینگ
import PersonaGrid from "../components/landing/PersonaGrid";
import FAQSection from "../components/landing/FAQSection";
import FinalCTA from "../components/landing/FinalCTA";
import Testimonials from "@/components/Testimonials";
import { useTrackerTestimonials } from "../testimonialsData/trackerTestimonials";
import HeroSection from "@/components/landing/TrackerHeroSection";
import TrackerFeatures from "@/components/landing/NonHealthFeatures/TrackerFeatures/index";
import LifestyleUseCasesTracker from "@/components/landing/deta-LifestyleUseCases/LifestyleUseCasesTracker";
import { motion } from "framer-motion";
import TrackerHardwareFeatures from "@/components/landing/deta-HardwareFeatures/TrackerHardwareFeatures";
import TrackerComparison from "@/components/landing/TrackerComparison";
import { trackerFaqs } from "../components/landing/deta-FAQ/trackerFaqs";
import { Helmet } from "react-helmet-async";

const TrackerPage: React.FC = () => {
  const productComparisonRef = useRef(null);
  const [triggerAnimation, setTriggerAnimation] = useState(0);
    const trackerTestimonials = useTrackerTestimonials();

    // Structured Data
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "ردیاب کودک دلبند",
    "description": "ردیاب کودک با قابلیت‌های GPS و تماس اضطراری",
    "brand": {
      "@type": "Brand",
      "name": "دلبند"
    },
    "category": "ردیاب کودک"
  };

  const scrollToProductComparison = () => {
    if (productComparisonRef.current) {
      // تاخیر کوتاه برای انیمیشن بهتر
      setTimeout(() => {
        ((productComparisonRef.current as unknown) as HTMLElement).scrollIntoView({
          behavior: 'instant', // بدون نمایش اسکرول
          block: 'start',
        });
        
        // trigger کردن انیمیشن با تغییر key
        setTimeout(() => {
          setTriggerAnimation(prev => prev + 1);
        });
      }, 300);
    }
  };

  return (
      <>
          <Helmet>
              <title>ردیاب دلبند - امنیت و آرامش خاطر برای والدین</title>
              <meta name="description" content="ردیاب کودک دلبند با قابلیت‌های GPS، حصار جغرافیایی و تماس اضطراری، امنیت و آرامش خاطر را برای والدین به ارمغان می‌آورد. همیشه از موقعیت فرزند خود باخبر باشید." />
              <meta name="keywords" content="ردیاب کودک, ردیاب GPS, امنیت کودک, حصار جغرافیایی, تماس اضطراری" />
              <link rel="canonical" href="https://delband.com/tracker" />
              <meta property="og:title" content="ردیاب کودک دلبند - امنیت و آرامش خاطر" />
              <meta property="og:url" content="https://delband.com/tracker" />
              <script type="application/ld+json">
                  {JSON.stringify(structuredData)}
              </script>
          </Helmet>
          <div className="bg-[#F8F9FC] relative w-full overflow-x-clip">
              <Header />
              <main className="container mx-auto px-2 pb-8 pt-26 sm:pt-24 md:pt-21 max-w-7xl overflow-x-clip">
                  <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#f4bb90] rounded-full blur-[120px] opacity-40 z-0 pointer-events-none"></div>
                  <div className="absolute bottom-0 left-[-14%] w-[300px] h-[300px] bg-gray-600 rounded-full blur-[120px] opacity-15 sm:opacity-25 z-[999999] pointer-events-none"></div>
                  {/* بخش قهرمان */}
                  <HeroSection onCompareClick={scrollToProductComparison} />

                  {/* بخش ویژگی‌های ردیابی */}
                  <TrackerFeatures />

                  {/* <DataFlowInsight /> */}
                  {/* بخش ویژگی‌های سخت‌افزاری */}
                  <TrackerHardwareFeatures />

                  {/* بخش فراتر از سلامت */}
                  {/* <BeyondHealthServices /> */}

                  {/* بخش کاربردهای روزمره */}
                  <LifestyleUseCasesTracker />

                  {/* بخش مناسب برای چه کسانی */}
                  <PersonaGrid />
                  {/* بخش مقایسه محصولات */}
                  <motion.div
                      key={triggerAnimation}
                      ref={productComparisonRef}
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      transition={{ duration: 0.6, ease: "easeOut" }}
                      viewport={{ once: false, margin: "-100px" }}
                  >
                      <TrackerComparison />
                  </motion.div>
                  {/* بخش نظرات کاربران */}
                  <Testimonials data={trackerTestimonials} translationNamespace="trackerTestimonials" />

                  {/* بخش سوالات متداول */}
                  <FAQSection faqs={trackerFaqs} translationNamespace="trackerFAQs" />

                  {/* بخش دعوت به عمل نهایی */}
                  <FinalCTA />
              </main>
              <Footer />
          </div>
      </>
  );
};

export default TrackerPage;
